import type { AvailableSlot } from '@/hooks/usePublicBooking';
import { clockFromIso } from '@/lib/portalFormat';

export { pickDefaultPortalPaymentChoice } from '@/lib/calendarPaymentChoice';

/** One visible time per civil clock — first available practitioner wins. */
export function uniqueSlotsByClock(slots: AvailableSlot[]): AvailableSlot[] {
  const seen = new Map<string, AvailableSlot>();
  const ordered = [...slots].sort((a, b) => {
    const start = a.start.localeCompare(b.start);
    if (start !== 0) return start;
    return a.clinician_id.localeCompare(b.clinician_id);
  });
  for (const slot of ordered) {
    const key = clockFromIso(slot.start);
    if (!key || seen.has(key)) continue;
    seen.set(key, slot);
  }
  return [...seen.values()];
}

export const MOBILE_DAY_SLOT_CAP = 8;

export function daySlotsToShow<T>(
  slots: T[],
  compact: boolean,
  expanded: boolean,
  cap = MOBILE_DAY_SLOT_CAP,
): { shown: T[]; hidden: number } {
  if (!compact || expanded || slots.length <= cap) {
    return { shown: slots, hidden: 0 };
  }
  return { shown: slots.slice(0, cap), hidden: slots.length - cap };
}
